import { Capacitor } from '@capacitor/core';
import {
  IonActionSheet,
  IonButton,
  IonButtons,
  IonImg,
  IonInput,
  IonLabel,
  isPlatform,
} from '@ionic/react';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import EntryManagedImg from '@/assets/imgs/entry-shop.svg';
import EntryManagedRed from '@/assets/imgs/entry-shop-error.svg';
import EntryManagedImgErrorRange from '@/assets/imgs/entry-shop-error-range.svg';
import ENVIRONMENT from '@/environments/environment';
import { ManagedModalRoutes } from '@/interfaces/ManagedModalInterface/ManagedModalInterface';
import {
  OcrAPIData,
  OcrAvailabilityConfigurationTypes,
  OcrFlowTypes,
  OcrType,
  PostInvoice,
} from '@/interfaces/OcrInterface/OcrInterface';
import { saveInvoiceManagedData } from '@/redux/invoiceManaged/invoiceManaged';
import { postOcr, postOcrAnalyze } from '@/redux/ocr/ocrAPI';
import { saveOrderManagedData } from '@/redux/orderManaged/orderManaged';
import { getMerchantsOrderCall } from '@/redux/orderManaged/orderManagedAPI';
import {
  DescriptionModalEntry,
  MessageError,
} from '@/redux/orderManaged/orderManagedInterface';
import InsightService from '@/services/insights';
import { RootState } from '@/store';
import { retrieveCommercialOffers } from '@/utils/commercialOfferHelper';
import { validateAndConvertFile } from '@/utils/imagePdfHelper';

import styles from './EntryManaged.module.scss';

interface EntryManagedProps {
  cartIdParam?: string;
  nextStep: (
    arg0: ManagedModalRoutes,
    isDocument?: boolean,
    isPreferred?: boolean,
  ) => void;
  handleLoading: (arg0: boolean) => void;
}

export default function EntryManaged({
  cartIdParam,
  nextStep,
  handleLoading,
}: EntryManagedProps) {
  const dispatch = useDispatch();

  const [cartInputValue, setCartInputValue] = useState<string | null>(null);
  const [errorType, setErrorType] = useState<string | null>(null);
  const [messageError, setMessageError] = useState<string | null>('');
  const [showError, setShowError] = useState<boolean>(false);
  const [description, setDescription] = useState<string>('');
  const [title, setTitle] = useState<string>();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [errorSubmittedFile, setErrorSubmittedFile] = useState<boolean>(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [isSubmitDisabled, setIsSubmitDisabled] = useState<boolean>(false);
  const ocrRequestData = useRef<OcrAPIData | null>(null);

  // RETOMACION
  // const operationData = useSelector((state: RootState) => state.operation).data?.data;
  const operationOrder = useSelector(
    (state: RootState) => state.operation,
  ).order;
  const retakenECO = sessionStorage.getItem('retaken-eco') === 'true';
  const operationOrderId = operationOrder?.order_id;
  const operationCartId = operationOrder?.cart_id;
  const [buttonRetakeDisabled, setButtonRetakeDisabled] = useState(true);
  const [buttonInitialDisabled, setButtonInitialDisabled] = useState(true);
  const checkpreferredOfferAndNoPreferredOffer = useSelector(
    (state: RootState) => state.commercialOffers.data.preferredOfferandNoPreferredOffer,
  );
  const [showActionSheet, setShowActionSheet] = useState(false);
  const [preferredOffer, setPreferredOffer] = useState<boolean>(
    checkpreferredOfferAndNoPreferredOffer,
  );

  useEffect(() => {
    setPreferredOffer(checkpreferredOfferAndNoPreferredOffer);
  }, [checkpreferredOfferAndNoPreferredOffer]);
  const cartIdFound = useSelector(
    (state: RootState) => state.cartIdManaged.data.cartIdFound,
  );
  const initTestData = async () => {
    try {
      try {
        const ocrResponse: any = {
          result: {
            status: true,
            http_code: 200,
            info: 'OK',
            errors: null,
          },
          data: {
            status: 'VLD',
            global_attempts_remaining: 2,
            analyze_attempts_remaining: 2,
            third_party_response: {
              total_price: 192.0,
              cart: {
                id: '12',
                cart_price: 0.0,
                products: [
                  {
                    id: 'F 4009',
                    name: 'SUSTITUCIÓN OTRAS BOMBILLAS (UNIDAD)',
                    qty: null,
                    price: 11.57,
                  },
                  {
                    id: 'A 68163',
                    name: '2BOMB W5W NORAUTO',
                    qty: null,
                    price: 2.07,
                  },
                  {
                    id: 'F 0900',
                    name: 'CONTROL AIRE ACONDICIONADO',
                    qty: null,
                    price: 9.59,
                  },
                  {
                    id: 'F 1505',
                    name: 'MONT PASTILLAS DELANTERAS',
                    qty: null,
                    price: 43.8,
                  },
                  {
                    id: 'A 924203',
                    name: 'PASTILLA FRENO NORAUTO NRP1594',
                    qty: null,
                    price: 31.4,
                  },
                  {
                    id: 'F 1536',
                    name: 'CAMBIO/PURGA LIQ.FRENOS (LIQ. INCLUIDO)',
                    qty: null,
                    price: 39.67,
                  },
                  {
                    id: 'F 1505',
                    name: 'MONT PASTILLAS DELANTERAS',
                    qty: null,
                    price: 43.8,
                  },
                ],
              },
              applicant: {
                id: '150000',
                name: 'SEÑORA',
                last_name: 'GOMEZ CERVERO MARI CARMEN',
                email: 'EMAIL@TEST.COM',
                phone: '617959129',
                document_id: null,
                billing_address: {
                  country: null,
                  city: 'MANISES',
                  province: null,
                  postal_code: '46940',
                  address: 'CALLE FIGUEROLES 1, 13 ',
                  phone: '617959129',
                },
                shipping_address: null,
              },
              document_type: 'INVOICE',
            },
          },
        };
        if (ocrResponse.data.status === 'VLD') {
          dispatch(saveInvoiceManagedData({ data: ocrResponse.data })); // Guardar los datos del pedido en el estado
          InsightService.logTrace(
            '4. MANAGED - avanzo a pedido localizado - presupuesto',
          );
          nextStep(
            ManagedModalRoutes.LOCALIZED_BUDGET_ORDER,
            true,
            preferredOffer,
          );
        } else {
          initialData();
          setTitle('¡Vaya!');
          setDescription(DescriptionModalEntry.ERROR_ORDER_DATA_FILE);
          setErrorSubmittedFile(true);
          setErrorType('errorRange');
        }
      } catch (error) {
        initialData();
        setTitle('¡Vaya!');
        setDescription(DescriptionModalEntry.ERROR_ORDER_DATA_FILE);
        setErrorSubmittedFile(true);
        setErrorType('errorRange');
      }
    } catch (error) {
      nextStep(ManagedModalRoutes.UNKNOWN_ERROR);
    }
  };
  useEffect(() => {
    if (retakenECO && operationCartId && operationOrderId) {
      InsightService.logTrace('1. MANAGED - retomación', [
        { retakenECO: operationCartId },
        { orderId: operationOrderId },
      ]);
      handleLoading(true);
      getOrderData();
    } else {
      initialData();
    }
  }, []);

  const initialData = () => {
    InsightService.logTrace('1. MANAGED - no retomación', [
      { cartId: cartIdFound },
    ]);
    setCartInputValue('');
    setShowError(false);
    setMessageError('');

    if (cartIdFound) {
      setDescription(
        'Introduce la referencia del pedido de tu e-commerce y comprobaremos si es posible recuperarlo. También puedes subir un presupuesto para que creemos un pedido con esa información.',
      );
      setTitle('Recuperar pedido');
    } else {
      setDescription(
        'Puedes subir un presupuesto para que creemos un pedido con esa información.',
      );
      setTitle('Lector presupuestos');
    }

    setErrorType(null);
    setErrorSubmittedFile(false);
  };

  const changeCartIdInput = (e: any) => {
    const { value } = e.target;
    setCartInputValue(value);
    if (value) {
      setButtonInitialDisabled(false);
    } else {
      setButtonInitialDisabled(true);
    }
    setErrorSubmittedFile(false);
  };

  const getErrorImage = (errorType: string | null) => {
    switch (errorType) {
      case 'error':
      case 'errorRange':
        return (
          <IonImg
            src={EntryManagedImgErrorRange}
            className={styles.errorRangeSize}
          />
        );
      case 'errorFile':
        return (
          <IonImg src={EntryManagedRed} className={styles.errorFileSize} />
        );
      default:
        return <IonImg src={EntryManagedImg} />;
    }
  };

  const handleContinue = async () => {
    handleLoading(true);
    setIsSubmitDisabled(false);
    setSelectedFile(null);
    try {
      InsightService.logTrace('2. MANAGED - continuar con id cart', [
        { cartId: operationCartId },
      ]);
      if (operationCartId && retakenECO) {
        // La decisión (retake / resumption-web / opciones) se resuelve en ShippingClientManaged.
        // Se mantiene el loading activo: ShippingClientManaged lo apaga o redirige.
        nextStep(ManagedModalRoutes.SHIPPING_CLIENT_MANAGED);
      } else {
        getOrderData();
      }
    } catch (error) {
      InsightService.logTrace('2. MANAGED - continuar con id cart error', [
        { error },
      ]);
      handleLoading(false);
      handleCartError(error);
    }
  };

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    InsightService.logTrace('2. MANAGED - continuar con presupuesto');
    handleLoading(true);
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      if (file.type === 'application/pdf' || file.type.startsWith('image/')) {
        setSelectedFile(file);
        if (file) {
          const result = await validateAndConvertFile(file, 2);
          if (!result.isValid) {
            handleLoading(false);
            initialData();
            setShowError(true);
            setErrorType('errorFile');
            setMessageError(result.error || MessageError.ERROR_ORDER_FILE);
            setButtonInitialDisabled(true);
            e.target.value = '';
            return;
          }
          if (result.base64 && result.isValid) {
            try {
              InsightService.logTrace('3. MANAGED - postOcr');
              const ocrData = await postOcr({
                flow: OcrFlowTypes.ORIGINATION_WITHOUT_PROPOSAL,
                availability_configuration:
                  OcrAvailabilityConfigurationTypes.ANALYZE,
                type: OcrType.INVOICE,
              });

              ocrRequestData.current = ocrData.data;
              const base64File = (result.base64 as string).split(',')[1];
              const fileAnalyze: PostInvoice = {
                document: base64File,
              };
              try {
                const ocrResponse = await postOcrAnalyze(
                  ocrRequestData.current.ocr_document_id,
                  fileAnalyze,
                );

                if (ocrResponse.data.status === 'VLD') {
                  dispatch(saveInvoiceManagedData({ data: ocrResponse.data })); // Guardar los datos del pedido en el estado
                  InsightService.logTrace(
                    '4. MANAGED - avanzo a pedido localizado - presupuesto',
                  );
                  nextStep(
                    ManagedModalRoutes.LOCALIZED_BUDGET_ORDER,
                    true,
                    preferredOffer,
                  );
                } else {
                  InsightService.logTrace(
                    '4. MANAGED - error ocr - presupuesto',
                    [{ ocrResponse: ocrResponse.data.status }],
                  );
                  initialData();
                  setTitle('¡Vaya!');
                  setDescription(DescriptionModalEntry.ERROR_ORDER_DATA_FILE);
                  setErrorSubmittedFile(true);
                  setErrorType('errorRange');
                }
              } catch (error) {
                InsightService.logTrace(
                  '4. MANAGED - error lectura presupuesto',
                  [{ ocrAnalyze: error }],
                );
                initialData();
                setTitle('¡Vaya!');
                setDescription(DescriptionModalEntry.ERROR_ORDER_DATA_FILE);
                setErrorSubmittedFile(true);
                setErrorType('errorRange');
              }
            } catch (error) {
              InsightService.logTrace('3. MANAGED - postOcr error ', [
                { error },
              ]);
              nextStep(ManagedModalRoutes.UNKNOWN_ERROR);
            }
          }
        }
      } else {
        nextStep(ManagedModalRoutes.UNKNOWN_ERROR);
      }
    }
    e.target.value = '';
    handleLoading(false);
  };

  const handleCartError = (exception: any) => {
    const operationAlreadyPaid = exception.result.errors.some((error: any) => error.message.includes('Cart paid'));
    if (operationAlreadyPaid) {
      initialData();
      setShowError(true);
      setErrorType('error');
      setMessageError(MessageError.ERROR_ORDER_ACCEPTED);
      setButtonInitialDisabled(true);
      // nextStep(ManagedModalRoutes.ORDER_ALREADY_ASSOCIATED);
    } else {
      initialData();
      setShowError(true);
      setErrorType('error');
      setMessageError(MessageError.ERROR_ORDER_REFERENCE);
      setButtonInitialDisabled(true);
    }
  };

  const handleCartErrorRetake = (exception: any) => {
    if (
      exception.result.http_code === 404
      || exception.result.http_code === 400
    ) {
      initialData();
      setShowError(true);
      setErrorType('errorFile');
      setButtonRetakeDisabled(false);
      setMessageError(MessageError.ERROR_REFERENCE_NOT_FOUND);
      handleLoading(false);
    } else {
      initialData();
      setShowError(true);
      setErrorType('error');
      setMessageError(MessageError.ERROR_ORDER_REFERENCE);
    }
    handleLoading(false);
  };

  const getOrderData = async () => {
    handleLoading(true);
    try {
      if (operationCartId || cartIdParam || cartInputValue) {
        const cart = cartInputValue ?? cartIdParam ?? operationCartId;
        if (retakenECO && !cartIdFound) {
          // La decisión se resuelve en ShippingClientManaged; se mantiene el loading activo.
          nextStep(ManagedModalRoutes.SHIPPING_CLIENT_MANAGED);
          return;
        }
        const orderDetailedData = (await getMerchantsOrderCall(cart!)).data;
        if (!retakenECO) {
          // Si no es retomación = pedido localizado
          InsightService.logTrace('3. MANAGED - getOrderData no retomacion');
          const availability: boolean = await checkCommercialOfferAvailability(
            orderDetailedData.total_price,
          );
          if (availability) {
            InsightService.logTrace(
              '4. MANAGED - getOrderData - hay ofertas comerciales',
            );
            dispatch(saveOrderManagedData({ data: orderDetailedData })); // Guardar los datos del pedido en el estado
            nextStep(
              ManagedModalRoutes.LOCALIZED_BUDGET_ORDER,
              false,
              preferredOffer,
            );
          }
        } else {
          // SE ENCUENTRA EL PEDIDO EN EL GET LA RETOMACIÓN, SE AVANZA AL ENVÍO AL CLIENTE
          InsightService.logTrace(
            '3. MANAGED - retomación getOrderData avanza a envío al cliente',
          );
          // Si es retomación = envío a cliente
          // Guardar los datos del pedido en el estado
          dispatch(saveOrderManagedData({ data: orderDetailedData }));
          // La decisión se resuelve en ShippingClientManaged; se mantiene el loading activo.
          nextStep(ManagedModalRoutes.SHIPPING_CLIENT_MANAGED);
          return;
        }
      } else {
        // Error en la recuperación del order / disponibilidad de ofertas comerciales
        handleManagedError();
      }
      handleLoading(false);
    } catch (error: any) {
      InsightService.logTrace('3. MANAGED - getOrderData error', [{ error }]);
      handleManagedError(error);
    }
  };

  const handleManagedError = (error?: any) => {
    if (!retakenECO) {
      handleCartError(error);
      handleLoading(false);
    } else {
      handleCartErrorRetake(error);
      handleLoading(false);
    }
  };

  const checkCommercialOfferAvailability = async (
    totalPrice: number,
  ): Promise<boolean> => {
    InsightService.logTrace('MANAGED - comprobar ofertas comerciales');
    const offerS = sessionStorage.getItem('pepper-commercial-offers-S');
    let commercialOffers;
    // comprombamos si ya tenemos las ofertas comerciales en el sessionStorage
    if (!offerS) {
      // si no las tenemos las recuperamos
      commercialOffers = await retrieveCommercialOffers();
      if (commercialOffers) {
        sessionStorage.setItem(
          'pepper-commercial-offers-S',
          JSON.stringify(commercialOffers),
        );
      }
    } else {
      // esto es lo que se guarda en el sessionStorage y se recupera
      commercialOffers = JSON.parse(offerS);
    }
    // comprobamos si hay ofertas comerciales
    if (commercialOffers) {
      // recorremos las ofertas comerciales para poder filtrar por el flujo ECO
      // eslint-disable-next-line no-restricted-syntax
      for (const offer of commercialOffers) {
        if (offer.flow === 'ECO') {
          // comprobamos si el importe total del pedido esta dentro del rango de financiacion
          const minAvailability: number = Math.min(
            ...offer.commercial_offers.map(
              (commercial_offer: any) => commercial_offer.min_amount,
            ),
          );
          const maxAvailability: number = Math.max(
            ...offer.commercial_offers.map(
              (commercial_offer: any) => commercial_offer.max_amount,
            ),
          );
          if (minAvailability > totalPrice || maxAvailability < totalPrice) {
            initialData();
            setShowError(true);
            setErrorType('errorRange');
            setMessageError(
              MessageError.ERROR_ORDER_RANGE(
                totalPrice,
                minAvailability,
                maxAvailability,
              ),
            );
            setButtonInitialDisabled(true);
            return false;
          }
        }
      }
    }

    return true;
  };

  return (
    <div className={styles.modalEntryManagedContainer}>
      <div className={styles.entryManagedTitleDescriptionWrapper}>
        <div className={styles.entryManagedTitleWrapper}>
          <IonLabel className={styles.modalEntryManagedTitle}>{title}</IonLabel>
        </div>
        <div className={styles.entryManagedTitleWrapper}>
          <IonLabel className={styles.modalEntryManagedDescription}>
            {description}
          </IonLabel>
        </div>
      </div>
      {ENVIRONMENT.ENV === 'development' && (
        <button onClick={initTestData} type="button">
          Test value lector presupuesto
        </button>
      )}

      <div className={styles.entryManagedImgWrapper}>
        {getErrorImage(errorType)}
      </div>
      {showError && (
        <div className={styles.errorBanner}>
          <IonLabel>{messageError}</IonLabel>
        </div>
      )}
      {cartIdFound && !retakenECO && (
        <IonInput
          type="text"
          label="Número de referencia"
          id="amount-input"
          labelPlacement="floating"
          className={styles.formAmountInput}
          onIonInput={(e: any) => changeCartIdInput(e)}
        />
      )}
      <div className={styles.modalEntryManagedButtonsWrapper}>
        <IonButtons>
          {cartIdFound && (
            <IonButton
              className="nextButton"
              // className={`${retakenECO ? 'next-btn-wrapper-entry next-button' : 'nextButton'}`}
              onClick={handleContinue}
              disabled={
                retakenECO ? buttonRetakeDisabled : buttonInitialDisabled
              }
            >
              Continuar
            </IonButton>
          )}
        </IonButtons>
        {!retakenECO && (
          <IonButtons className={styles.nextBtnWrapperEntry}>
            <IonButton
              className="nextButton"
              onClick={() => {
                if (Capacitor.isNativePlatform() && isPlatform('android')) {
                  setShowActionSheet(true); // menú flotante solo en Android nativo
                } else {
                  document.getElementById('file-input')?.click(); // Abrir el input de archivo directamente
                }
              }}
              disabled={isSubmitDisabled}
            >
              Subir presupuesto
            </IonButton>

            <input
              id="file-input"
              type="file"
              accept=".pdf,image/*"
              style={{ display: 'none' }} // Oculta el input de archivo
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleFileChange(e)}
            />
          </IonButtons>
        )}

        <IonActionSheet
          isOpen={showActionSheet}
          onDidDismiss={() => setShowActionSheet(false)} // Cierra el menú al hacer clic fuera
          buttons={[
            {
              text: 'Seleccionar archivo',
              handler: () => {
                document.getElementById('file-input')?.click(); // Activa el input para seleccionar archivo
              },
            },
            {
              text: 'Hacer foto',
              handler: () => {
                document.getElementById('camera-input')?.click(); // Activa el input para capturar foto
              },
            },
            {
              text: 'Cancelar',
              role: 'cancel', // Cierra el menú
            },
          ]}
        />

        {/* Input para capturar foto */}
        <input
          id="camera-input"
          type="file"
          capture="environment" // Activa la cámara
          accept="image/*"
          style={{ display: 'none' }} // Oculta el input
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleFileChange(e)}
        />
      </div>
    </div>
  );
}
